module.exports = __webpack_public_path__ + "static/media/Horizantal_Nav_Top_onhover Size_62x62.3120c88c.png";